"use strict";

var _regeneratorRuntime = require("@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Web3 = require("web3");

var types_1 = require("../../types");

exports.ERC721Schema = {
  version: 2,
  deploymentBlock: 0,
  name: 'ERC721',
  description: 'Items conforming to the ERC721 spec, using transferFrom.',
  thumbnail: 'https://opensea.io/static/images/opensea-icon.png',
  website: 'http://erc721.org/',
  fields: [{
    name: 'ID',
    type: 'uint256',
    description: 'Asset Token ID'
  }, {
    name: 'Address',
    type: 'address',
    description: 'Asset Contract Address'
  }],
  assetFromFields: function assetFromFields(fields) {
    return {
      id: fields.ID,
      address: fields.Address
    };
  },
  assetToFields: function assetToFields(asset) {
    return {
      ID: asset.id,
      Address: asset.address
    };
  },
  formatter: function formatter(asset) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                title: 'ERC721 Asset: Token ID ' + asset.id + ' at ' + asset.address,
                description: '',
                url: '',
                thumbnail: '',
                properties: []
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  },
  functions: {
    transfer: function transfer(asset) {
      return {
        type: Web3.AbiType.Function,
        name: 'transferFrom',
        payable: false,
        constant: false,
        stateMutability: types_1.StateMutability.Nonpayable,
        target: asset.address,
        inputs: [{
          kind: types_1.FunctionInputKind.Owner,
          name: '_from',
          type: 'address'
        }, {
          kind: types_1.FunctionInputKind.Replaceable,
          name: '_to',
          type: 'address'
        }, {
          kind: types_1.FunctionInputKind.Asset,
          name: '_tokenId',
          type: 'uint256',
          value: asset.id
        }],
        outputs: []
      };
    },
    ownerOf: function ownerOf(asset) {
      return {
        type: Web3.AbiType.Function,
        name: 'ownerOf',
        payable: false,
        constant: true,
        stateMutability: types_1.StateMutability.View,
        target: asset.address,
        inputs: [{
          kind: types_1.FunctionInputKind.Asset,
          name: '_tokenId',
          type: 'uint256',
          value: asset.id
        }],
        outputs: [{
          kind: types_1.FunctionOutputKind.Owner,
          name: 'owner',
          type: 'address'
        }]
      };
    },
    assetsOfOwnerByIndex: []
  },
  events: {
    transfer: []
  },
  hash: function hash(asset) {
    return asset.address + '-' + asset.id;
  }
};